$shm_hitalama_map_widget_float_component_view $shm_hitalama_map_widget_float_customdom
	content /
		^ wrapper
	head /
		^
		<= Open_in_new
